module.exports = __webpack_public_path__ + "static/media/still-tasting.ad54b974.svg";